<div class="dialog-header">
  <h2>Cancel Subscription</h2>
  <button class="x-btn" (click)="close()">&#10005;</button>
</div>

<div class="dialog-body">
  <div class="form-group">
    <label>Cancel Reason</label>
    <input type="text" [(ngModel)]="form.cancelReason" />
  </div>
</div>

<div class="dialog-footer">
  <button class="close-btn" (click)="close()">Close</button>
  <button class="submit-btn" (click)="submit()">Submit</button>
</div>
